import { KTSVG, toAbsoluteUrl } from '../_metronic/helpers'
const CanvasLoader = () => {
    return (
        <div className="d-flex justify-content-center align-items-center">
        <span className='indicator-progress' style={{ display: 'block' }}>
            <span className='spinner-border spinner-border-md ms-2 mt-12'></span>
        </span>
    </div>
    )
}
export default CanvasLoader